function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Mmenu from 'mmenu-js';
import { Offcanvas } from 'bootstrap';
document.addEventListener('DOMContentLoaded', function () {
  // Search Toggle
  var searchToggle = document.querySelector('.search-toggle');
  var searchOffcanvas = document.getElementById('offcanvasTop');
  var banner = document.querySelector('.banner');
  var body = document.querySelector('body');

  if (searchToggle && searchOffcanvas && banner) {
    var hideOffcanvas = function hideOffcanvas() {
      if (searchOffcanvas.classList.contains('show')) {
        offcanvas.hide();
      }
    };

    var offcanvas = Offcanvas.getInstance(searchOffcanvas);
    searchOffcanvas.addEventListener('show.bs.offcanvas', function () {
      searchToggle.classList.add('open');
      body.classList.add('open');
    });
    searchOffcanvas.addEventListener('shown.bs.offcanvas', function () {
      banner.addEventListener('click', hideOffcanvas);
    });
    searchOffcanvas.addEventListener('hide.bs.offcanvas', function () {
      searchToggle.classList.remove('open');
      body.classList.remove('open');
    });
    searchOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
      banner.removeEventListener('click', hideOffcanvas);
    });
  } // Mmenu


  var buttonFindDTN = document.querySelector('.btn-find-dtn');
  var buttonMySpace = document.querySelector('.btn-myspace');
  var secondaryMenu = document.querySelector('#secondary-menu-top');
  var socialMedias = document.querySelectorAll('.social-medias .social-media');

  if (buttonFindDTN && buttonMySpace && secondaryMenu && socialMedias) {
    var socialMediasHTML = '';
    socialMedias.forEach(function (socialMedia) {
      socialMediasHTML += socialMedia.outerHTML;
    });
    var footer = "<div class=\"bg-white\">\n                      <div class=\"bg-white d-flex flex-column justify-content-center align-items-center py-60\">".concat(buttonFindDTN.outerHTML).concat(buttonMySpace.outerHTML, "</div>\n                      <div class=\"bg-light py-30 px-3 d-flex\">\n                        <div class=\"col-6 left-menu\">").concat(secondaryMenu.outerHTML, "</div>\n                        <div class=\"col-6 d-flex justify-content-end align-items-end\"><ul class=\"nav\">").concat(socialMediasHTML, "</ul></div>\n                      </div>\n                    </div>\n                   ");
    new Mmenu('#mobile-menu', {
      slidingSubmenus: false,
      navbar: {
        add: false
      },
      offCanvas: {
        pageSelector: '#page'
      },
      extensions: {
        all: ['position-left', 'position-front', 'border-full', 'theme-white'],
        '(max-width: 600px)': ['fullscreen']
      }
    });
    var menuContainer = document.querySelector('.menu-menu-mobile-container');
    menuContainer.innerHTML += footer;
  } // Primary Menu


  var primaryMenu = document.querySelector('#primary-menu');
  var primaryMenuChildren = primaryMenu.children;

  if (primaryMenuChildren) {
    (function () {
      var removeAllShowClassFromMenu = function removeAllShowClassFromMenu() {
        primaryMenu.querySelectorAll('.show').forEach(function (elementWithClassShow) {
          elementWithClassShow.classList.remove('show');
        });
      };

      var _iterator = _createForOfIteratorHelper(primaryMenuChildren),
          _step;

      try {
        var _loop = function _loop() {
          var primaryMenu = _step.value;
          var primaryMenuTitle = primaryMenu.querySelector('a');
          var primaryMenuContent = primaryMenu.querySelector('ul');

          if (primaryMenuTitle) {
            primaryMenuTitle.href = '#';
            primaryMenuTitle.addEventListener('click', function (e) {
              // Remove the offcanvas to not have the two superposed
              if (offcanvas) {
                offcanvas.hide();
              }

              if (primaryMenuTitle.classList.contains('show')) {
                removeAllShowClassFromMenu();
              } else {
                removeAllShowClassFromMenu();
                primaryMenuTitle.classList.add('show');

                if (primaryMenuContent) {
                  primaryMenuContent.classList.add('show');
                }
              }

              e.stopPropagation();
            });
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      document.addEventListener('click', function () {
        removeAllShowClassFromMenu();
      });
    })();
  } // Sidebar Page Menu (Mobile)


  var sidebarMenu = document.querySelector('.sidebar-mobile li');

  if (sidebarMenu) {
    var parentTitle = sidebarMenu.querySelector(':scope > a');

    if (parentTitle) {
      parentTitle.href = '#';
    }

    sidebarMenu.addEventListener('click', function () {
      this.classList.toggle('open');
    });
  }
});